import { render } from "./RelationshipTypes.vue?vue&type=template&id=959cb4c0&scoped=true"
import script from "./RelationshipTypes.vue?vue&type=script&lang=js"
export * from "./RelationshipTypes.vue?vue&type=script&lang=js"

import "./RelationshipTypes.vue?vue&type=style&index=0&id=959cb4c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-959cb4c0"]])

export default __exports__